import { render, staticRenderFns } from "./TemplateMessageList.vue?vue&type=template&id=e59485a6&"
import script from "./TemplateMessageList.vue?vue&type=script&lang=js&"
export * from "./TemplateMessageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports